import { DatePicker, Form, message, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRpmCarePlanTaskList,
  fetchRpmFrequenciesList,
  fetchRpmTasksList,
} from "../../../../../../../Redux/actions/rpmActions";
import rpmService from "../../../../../../../Services/rpmService";
import { convertUTCDate } from "../../../../../../../utils/convertionFunc";

function SetCarePlanTask({ handleClose }) {
  const [loader, setLoader] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const formRef = useRef();
  const { selectedRpmPatient, tasksList, frequenciesList } = useSelector(
    (state) => state.rpm
  );
  const dispatch = useDispatch();
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    const payload = {
      status: 1,
    };
    dispatch(fetchRpmTasksList(payload));
    dispatch(fetchRpmFrequenciesList(payload));
  }, []);

  const handleTaskSet = async () => {
    const { code, frequencyCode, fromDate, toDate } =
      formRef.current.getFieldsValue();


    if (!code || !frequencyCode || !fromDate || !toDate) {
      message.error("Please fill in mandatory fields");
      return;
    }

    setLoader(true);
    const payload = {
      account_Id: selectedRpmPatient.account_Id,
      clinic_id: selectedRpmPatient.clinic_Id,
      createdBy: loggedUser?.user?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      frequencyCode,
      fromDate: convertUTCDate(fromDate, "MM/DD/YYYY"),
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: selectedRpmPatient.patientId,
      status: 1,
      taskCode: code,
      toDate: convertUTCDate(toDate, "MM/DD/YYYY"),
      userId: selectedRpmPatient.createdBy,
    };

    try {
      await rpmService.addCarePlanTask(payload);
      setLoader(false);
      const carePlanTaskpayload = {
        patientId: selectedRpmPatient.patientId,
        status: 1,
      };
      dispatch(fetchRpmCarePlanTaskList(carePlanTaskpayload));
      handleClose();
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  const handleSelectedTask = (taskCode) => {
    const item = tasksList.find((d) => d.code === taskCode);
    if (!item) return;

    setSelectedTask(item);
    formRef.current.setFieldsValue({
      description: item.description,
    });
  };

  return (
    <>
      <Form layout="vertical" ref={formRef}>
        <div className="grid grid-cols-1 items-center gap-2">
          <div>
            <Form.Item
              label={
                <span>
                  Title<span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="code"
            >
              <Select
                placeholder="Select"
                style={{
                  width: "100%",
                }}
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={handleSelectedTask}
              >
                {tasksList.map((item, idx) => (
                  <Select.Option key={idx} value={item.code}>
                    {item.name}
                  </Select.Option>
                ))}
                {/* Option for free-text entry */}
                <Select.Option key="other" value="other" label="Other">
                  Other
                </Select.Option>
              </Select>
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Task<span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="description"
            >
              <TextArea placeholder="Description" rows={3} />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Frequency<span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="frequencyCode"
            >
              <Select
                placeholder="Select"
                style={{
                  width: "100%",
                }}
                options={frequenciesList.map((ele) => ({
                  value: ele.code,
                  label: ele.description,
                }))}
              />
            </Form.Item>
          </div>
          <div className="w-full grid grid-cols-2 gap-2">
            <div>
              <Form.Item
                label={
                  <span>
                    From Date <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
                name="fromDate"
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </div>
            <div>
              <Form.Item
                label={
                  <span>
                    To Date <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
                name="toDate"
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>
      <div className="flex items-center w-full justify-end my-5">
        <button
          onClick={handleClose}
          className="border-brand-primaryColor border bg-white rounded text-brand-primaryColor text-sm px-6 py-1"
        >
          Cancel
        </button>
        <button
          disabled={loader}
          onClick={handleTaskSet}
          className="bg-brand-primaryColor text-white border-brand-primaryColor border rounded px-5 py-1 text-brand-textWhite text-sm ml-3 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Submit
        </button>
      </div>
    </>
  );
}

export default SetCarePlanTask;
